import { useAuthStore } from "@/stores/auth";
import { useOrgStore, type OrgRole } from "@/stores/org";

/**
 * Single source of truth for role-gated visibility. Shared by the top nav /
 * profile dropdown (App.vue) today, and intended for the upcoming
 * meta.requiresRole router guards (M11/L18) so role logic isn't duplicated
 * between the two.
 *
 * Superadmins (authStore.isSuperadmin) always pass, mirroring the carve-out
 * router/index.ts already gives them for meta.isSuperadminRoute. Everyone
 * else is checked against the current org's pivot role
 * (orgStore.currentRole) — the same owner/admin/staff/finance role already
 * driving Billing/treasury/etc. visibility.
 */
export function useRole() {
  const authStore = useAuthStore();
  const orgStore = useOrgStore();

  const hasRole = (required: OrgRole | OrgRole[]): boolean => {
    if (authStore.isSuperadmin) return true;

    const allowed = Array.isArray(required) ? required : [required];
    return (
      orgStore.currentRole != null && allowed.includes(orgStore.currentRole)
    );
  };

  return { hasRole };
}
